import {AppContext, loadNextPage} from '../state';
import React, {useContext} from 'react';

/**
 * @typedef PagesHookValues
 * @property {string} currentPageUrl - the current pages url path
 * @property {string} currentPageType - the current page type
 * @property {string} defaultPageTitle - original title of the guide (usually via initial DOM load)
 * @property {function} getCurrentPage - returns current page object
 * @property {function} goToNextPage - loads next page
 * @property {function} goToPreviousPage - loads previous page
 * @property {Boolean} isAnimatingPages - returns the current animation stage as a string, or false if no animation is running
 * @property {Boolean} isLoadingNextPage - returns direction string when loading next page, or false is app is done loading page
 * @property {Object} progress - current app progress
 * @property {Object} savedPages - set of pages that have been accessed, with url as key
 * @property {Array} validationErrors - page validation errors
 *
 */
/**
 *
 * @returns {PagesHookValues}
 */
const usePages = () => {
  const { dispatch, pages:statePagesObj } = useContext(AppContext);
  const { currentPageUrl, savedPages } = statePagesObj;
  const getCurrentPage = () => Object.prototype.hasOwnProperty.call( savedPages, currentPageUrl ) ? savedPages[currentPageUrl] : null;
  const goToNextPage = React.useCallback(() => dispatch(loadNextPage(false)), [ dispatch ]);
  const goToPreviousPage = React.useCallback(() => dispatch(loadNextPage(true)), [ dispatch ]);

  return {
    ...statePagesObj,
    getCurrentPage,
    goToNextPage,
    goToPreviousPage
  };
};

export { usePages };
